import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useFilters } from "../Filters.hook";

const FRAGMENT_PUBLICATIONDATES_OPTIONS = new FragmentDefiner(
	"Filter",
	`
		id
		name
		options
	`
);

export const FRAGMENT_PUBLICATIONDATES = new FragmentDefiner(
	"Filters",
	`
		publicationDate {
			${FRAGMENT_PUBLICATIONDATES_OPTIONS.query()}
		}
	`
);

export const usePublicationDate = () => {
	const { filters } = useFilters();

	const type = "radio";

	return {
		show: true,
		data: {
			value: filters?.publicationDate,
			type: type,
		},
	};
};
